var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"h3 mb-3"},[_c('strong',[_vm._v("Page")]),_vm._v("  Not Found\n")])
}]

export { render, staticRenderFns }